@if (isWaitingAlertEnabled()) {
  <app-alert
    text="{{ widgetTemplates | calioMeetingTemplate: { id: templateConstant.WIDGET_WAITING_LIST_HINT, type: 'template' } | translation: templateContent.TEMPLATE_CONTENT: lang }}"
    type="warning"
  />
}

@if (eventState.date) {
  <div>
    @if (terminLoaded) {
      @if (eventOnDate?.length > 0) {
        <div>
          @for (eventInfo of (loadMoreSlots ? eventOnDate: (eventOnDate | slice:0:10)); track eventInfo;) {
            <ng-container class="form-input checkbox">
              <div
                class="label-container d-flex cbw-event-slot-card"
                [ngClass]="{
                  'cbw-selected-event-card': isTerminInCart(eventInfo.id),
                  'disabled-input': (!displayRegularData(eventInfo) && !displayWaitingData(eventInfo)) || isSlotBooked(eventInfo.id)
                }"
              >
                <div class="w-100 cbw-event-slot-lg">
                  <app-cw-checkbox-radio-button
                    class="w-100"
                    containerClass="ps-0"
                    labelClass="flex-direction-col w-100 hide-custom-control-label"
                    [customId]="eventInfo.id"
                    [name]="'freeEvents' + eventInfo.id"
                    [value]="eventInfo.id"
                    [checked]="isTerminInCart(eventInfo.id)"
                    [isCheckbox]="true"
                    [isDisabled]="(!displayRegularData(eventInfo) && !displayWaitingData(eventInfo)) || isSlotBooked(eventInfo.id)"
                    (selectionChange)="updateCart($event.event, eventInfo)"
                  >
                    <span class="event-info-text col-lg-6 ">
                      @if (eventInfo?.title) {
                        <span class="event-title cbw-event-title">
                          {{ eventInfo.title }}
                        </span>
                      }
                      @if (eventState?.is_multi_day === 0) {
                        <div>
                          {{ eventInfo.start | date:timeFormat }} - {{ eventInfo.end | date:timeFormat }}
                        </div>
                      } @else if (eventState?.is_multi_day === 1) {
                        <div>
                          @if (checkIfStartEndDatesAreEqual(eventInfo.start, eventInfo.end)) {
                            <span class="value">
                              {{ eventInfo.start | date:datePipeWithComma }} - {{ eventInfo.end | date:timeFormat }}
                            </span>
                          } @else {
                            <span class="value">
                              {{ eventInfo.start | date:dateTimeFormat }} - {{ eventInfo.end | date:dateTimeFormat }}
                            </span>
                          }
                        </div>
                      }

                      @if (eventState?.is_multi_day === 1 && eventInfo?.child_slots?.length > 0) {
                        <div class="cbw-event-info-child-slot">
                          <ul class="ps-3">
                            @for (childSlot of eventInfo.child_slots; track childSlot) {
                              <li class="event-info-child-slot pt-1">
                                {{ childSlot.start | date:dateTimeFormat }} - {{ childSlot.end | date:timeFormat }}
                              </li>
                            }
                          </ul>
                        </div>
                      }
                    </span>

                    @if (!displayRegularData(eventInfo)) {
                      <div class="col-lg-6 event-slot-bookedout">
                        @if (displayWaitingData(eventInfo)) {
                          @let waiting_count = eventInfo?.waitinglist_capacity - eventInfo?.waitinglist_booking_count;
                            <span
                            [innerHTML]="(
                              waiting_count === 1 ? 'alert_messages.singular_waitinglist_is_available' : 'alert_messages.plural_waitinglist_is_available'
                            ) | translate: { number: waiting_count } | trustHtml">
                          </span>
                        } @else {
                          <span>
                            {{ 'alert_messages.window_is_fully_booked' | translate }}
                          </span>
                        }
                        <ng-container *ngTemplateOutlet="eventLocation; context: { $implicit: eventInfo }"/>
                      </div>
                    }

                    @if (displayRegularData(eventInfo) && !isSlotBooked(eventInfo.id)) {
                      <span class="event-slot-bookedout col-lg-6">
                        @if (hideEventCapacity === 0) {
                          <div>
                            @if ((eventInfo.regular_capacity - eventInfo.regular_booking_count) === 1) {
                              <span [innerHTML]="('events.step2.regular_count_singular' | translate) | trustHtml"></span>
                            }
                            @if ((eventInfo.regular_capacity - eventInfo.regular_booking_count) > 1) {
                              <span
                                [innerHTML]="('events.step2.regular_count_plural' | translate: { number: (eventInfo.regular_capacity - eventInfo.regular_booking_count) }) | trustHtml"
                              ></span>
                            }
                          </div>
                          <div>
                            @if ((eventInfo.waitinglist_capacity - eventInfo.waitinglist_booking_count) === 1) {
                              <span [innerHTML]="('events.step2.waiting_count_singular' | translate) | trustHtml"></span>
                            } @else if ((eventInfo.waitinglist_capacity - eventInfo.waitinglist_booking_count) > 1) {
                              <span
                                [innerHTML]="('events.step2.waiting_count_plural' | translate: {number: (eventInfo.waitinglist_capacity - eventInfo.waitinglist_booking_count)}) | trustHtml"
                              ></span>
                            }
                          </div>
                        } @else {
                          <div>
                            <span>{{ 'events.step2.free_seats' | translate }}</span>
                          </div>
                          @if ((eventInfo.waitinglist_capacity - eventInfo.waitinglist_booking_count) >= 1) {
                            <div>
                              <span>{{ 'events.step2.free_waiting_seats' | translate }}</span>
                            </div>
                          }
                        }

                        <ng-container *ngTemplateOutlet="eventLocation; context: { $implicit: eventInfo }"/>
                      </span>
                    }
                  </app-cw-checkbox-radio-button>
                </div>
                <div class="next-arrow-container">
                  @if (isTerminInCart(eventInfo.id)) {
                    <span (click)="gotoNextPage()">
                      <fa-icon class="icon cbw-next-arrow-button d-flex" icon="chevron-circle-right"></fa-icon>
                    </span>
                  }
                </div>
              </div>
            </ng-container>
          }

          @if (!loadMoreSlots && eventOnDate?.length > 0 && eventOnDate?.length > 10) {
            <div class="d-flex justify-content-center load-more-button mt-4">
              <a class="load-more-link" href="javascript:void(0)" (click)="loadMore()">
                {{ 'load_more' | translate }}
              </a>
            </div>
          }
        </div>
      } @else {
        <app-alert text="{{ 'events.step1.noFreeSlots' | translate }}" type="danger" />
      }
    } @else {
      <app-loader aria-label="Loading slots" />
    }
  </div>
}

<ng-template #eventLocation let-eventInfo>
  @if (showWidgetSlotLocation) {
    <div class="cbw-summary-date-time d-flex mt-1">
      @if (eventInfo?.location) {
        @if (
          [1, 12].includes(eventInfo?.meeting_type_id) &&
          eventInfo?.location?.trim() !== ',' &&
          (eventInfo?.location | isEmptyString)
        ) {
          {{ 'common.location' | translate }}: {{ eventInfo?.location }}
        } @else if (eventInfo?.meeting_type_id && ![1, 12]?.includes(eventInfo?.meeting_type_id)) {
          <ng-container *ngTemplateOutlet="meetingType; context: { eventInfo: eventInfo }"/>
        }
      } @else {
        @if (
          [1, 12].includes(eventState?.meeting_type_id) &&
          eventState?.place?.trim() !== ',' &&
          (eventState?.place | isEmptyString)
        ) {
          {{ 'common.location' | translate }}: {{ eventState?.place }}
        } @else if (![1, 12]?.includes(eventState?.meeting_type_id) && eventState?.meeting_type_id) {
          <ng-container *ngTemplateOutlet="meetingType; context: { eventInfo: eventState }"/>
        }
      }
    </div>
  }
</ng-template>

<ng-template #meetingType let-eventInfo="eventInfo">
  @if (eventInfo?.meeting_type_id === 1) {
    <img src="{{ environment.baseUrl }}/images/meetings/store.svg" alt="Store Logo" width="15px" />
  } @else if (eventInfo?.meeting_type_id === 2) {
    <img src="{{ environment.baseUrl }}/images/meetings/zoom.svg" alt="Zoom Logo" width="15px" />
  } @else if (eventInfo?.meeting_type_id === 4) {
    <img src="{{ environment.baseUrl }}/images/meetings/phone.svg" alt="Phone Logo" width="15px" />
  } @else if (eventInfo?.meeting_type_id === 5) {
    <img src="{{ environment.baseUrl }}/images/meetings/customer.svg" alt="Customer Logo" width="15px" />
  } @else if (eventInfo?.meeting_type_id === 6) {
    <img src="{{ environment.baseUrl }}/images/meetings/unblu.svg" alt="Unblu Logo" width="15px" />
  } @else if (eventInfo?.meeting_type_id === 7) {
    <img src="{{ environment.baseUrl }}/images/meetings/teams.svg" alt="Teams Logo" width="15px" />
  } @else if (eventInfo?.meeting_type_id === 8) {
    <img src="{{ environment.baseUrl }}/images/meetings/meet.svg" alt="Meet Logo" width="15px" />
  } @else if (eventInfo?.meeting_type_id === 9) {
    <img src="{{ environment.baseUrl }}/images/meetings/gotomeeting.png" alt="Gotomeeting Logo" width="15px" />
  } @else if (eventInfo?.meeting_type_id === 10) {
    <img src="{{ environment.baseUrl }}/images/meetings/webex.png" alt="Webex Logo" width="15px" />
  } @else if (eventInfo?.meeting_type_id === 11) {
    <img src="{{ environment.baseUrl }}/images/meetings/phone.svg" alt="Phone Logo" width="15px" />
  } @else if (eventInfo?.meeting_type_id === 13) {
    <img src="{{ environment.baseUrl }}/images/meetings/metaverse.svg" alt="Metaverse" width="15px" />
  } @else if (eventInfo?.meeting_type_id === 15) {
    <img src="{{ environment.baseUrl }}/images/meetings/kmeet.png" alt="kMeet" width="15px" />
  }
  @if ((widgetTemplates | calioMeetingTemplate: { id: eventInfo?.meeting_type_id, type: 'meeting_template' }); as widgetTemplate) {
    <div class="meeting-option">
      @if ((widgetTemplate.titleTemplate | translation: templateContent.TEMPLATE_CONTENT: lang)) {
        <div class="meeting-type-name"
          [innerHTML]="(widgetTemplate.titleTemplate | translation: templateContent.TEMPLATE_CONTENT: lang) | trustHtml">
        </div>
      }
    </div>
  }
</ng-template>

